import { jsx as _jsx } from "react/jsx-runtime";
import humanizeString from "string-humanize";
import { Box } from "@chakra-ui/react";
import { BooleanDot } from "../../BooleanDot";
const createBooleanColumn = (key, options = {}) => (Object.assign({ id: key, accessorKey: key, header: () => humanizeString(key), cell: (data) => {
        return (_jsx(Box, { width: "100%", padding: "0px 1rem", children: _jsx(BooleanDot, { value: data.getValue() }) }));
    } }, options));
export default createBooleanColumn;
//# sourceMappingURL=booleanColumn.js.map